import relatoriosPesquisaSatisfacaoRoutes from '../modules/pesquisaSatisfacao/routes'

const RelatoriosPesquisaSatisfacao = () =>
  import(/* webpackChunkName: "group-satisfaction-research"*/ '../views/RelatoriosPesquisaSatisfacao')

import { permissoesRelatoriosPesquisa } from '../../../utils/permissoesPesquisaSatisfacao'

export default [
  {
    path: 'relatorios',
    component: RelatoriosPesquisaSatisfacao,
    meta: { requiresAuth: true, permissions: [...permissoesRelatoriosPesquisa] },
    children: [...relatoriosPesquisaSatisfacaoRoutes],
  },
]
